import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Analisis/filtrarAnalisis`, method: 'POST', body: values, token: token})
}
